<template>
  <div>
    <nav-bar :title="titlePage"></nav-bar>
    <taskFormSkeleton v-if="loading"> </taskFormSkeleton>
    <div v-else>
      <div class="mb-5 mobile p-4 layout-tasks">
        <confirm-modal
          :title="confirmModalData.title"
          :confirm-button="confirmModalData.confirmButton"
        >
          {{ confirmModalData.text }}
        </confirm-modal>
        <b-row class="mb-2 pt-4">
          <b-col cols="8" sm="9">
            <h5 class="font-weight-bold text-main m-0">{{ task.title }}</h5>
          </b-col>
          <b-col v-if="this.userIsAParent && parentCanEdit" cols="4" sm="3" class="text-right">
            <i class="material-icons-outlined align-middle p-1 mr-3 cursor" @click="editTask">
              border_color
            </i>
            <i class="material-icons-outlined align-middle p-1  cursor" @click="showDeleteTask">
              delete
            </i>
          </b-col>
        </b-row>
        <b-row class="my-3 py-2">
          <b-col cols="12">
            <div class="d-flex justify-content-end pb-3 border-main-bottom">
              <div>
                <stop-watch-button
                  class="gap-2 w-100"
                  v-if="showWatch"
                  :defaultTime="getTaskTimerSeconds"
                  :showActions="showActions"
                  @toggleTimer="toggleTimer"
                ></stop-watch-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <div v-if="task.priority" class="my-3 d-flex">
          <span class="text-capitalize mr-3 px-3 py-1 bg-secundary rounded-pill text-white">
            {{ task.type_text }}
          </span>
          <span
            :class="`bg-pri-${task.priority.description.toLowerCase()}`"
            class="text-white px-3 py-1 d-flex align-items-center rounded-pill"
          >
            <i class="material-icons medium-icon mr-1">flag</i>
            <p class="d-inline-block m-0 text-capitalize">
              {{ task.priority.description }}
            </p>
          </span>
        </div>
        <b-row class="my-3 py-2">
          <b-col cols="6">
            <p class="m-0 text-left font-weight-bold">Class</p>
          </b-col>
          <b-col cols="6">
            <p class="m-0 text-right">{{ task.subject_name }}</p>
          </b-col>
        </b-row>
        <b-row v-if="task.project" class="my-3 py-2">
          <b-col cols="6">
            <p class="font-weight-bold text-left m-0">Project</p>
          </b-col>
          <b-col cols="6">
            <p class="m-0 text-right">{{ task.project }}</p>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col cols="6">
            <p class="font-weight-bold m-0">When is it due?*</p>
            <p class="small my-2">{{ formatNameDay(task.due_date) }}</p>
          </b-col>
          <b-col cols="6" class="text-right">
            <span class="material-icons-outlined medium-icon">event_available</span>
            <p class="small my-2">{{ formatInMeridianTime(task.due_date) }}</p>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col cols="6">
            <p class="font-weight-bold m-0">When will you do it?</p>
            <p class="small my-2">{{ formatNameDay(task.start_date) }}</p>
          </b-col>
          <b-col cols="6" class="text-right">
            <span class="material-icons-outlined medium-icon">today</span>
            <p class="small my-2">{{ formatInMeridianTime(task.start_date) }}</p>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col cols="6">
            <p class="text-uppercase text-main m-0 small-icon">Repeat</p>
            <p class="text-capitalize">{{ task.repeat_text }}</p>
          </b-col>
        </b-row>
        <b-row v-if="task.notification_type !== '1'" class="my-2">
          <b-col cols="6">
            <p class="text-uppercase text-main m-0 small-icon">Notification</p>
            <p>{{ task.notification_text }}</p>
          </b-col>
          <b-col cols="6" v-if="task.notification_type === '4' && task.notification_date">
            <p class="text-uppercase text-main m-0 small-icon">Notification time</p>
            <p>{{ formatNameDay(task.notification_date) }}</p>
          </b-col>
        </b-row>
        <b-row class="py-2" v-if="task.description">
          <b-col cols="12">
            <p class="text-uppercase text-main m-0 small-icon">Notes</p>
            <p class="text-break">{{ task.description }}</p>
          </b-col>
        </b-row>
        <b-row v-if="task.attachment" class="align-items-center pb-4">
          <b-col cols="12" class="text-truncate">
            <p class="text-uppercase text-main m-0 small-icon">Attach file</p>
            <b-img fluid :src="task.attachment" class="fit-image-horizontal attachment"></b-img>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar } from '@/common/components';
import { getTaskInfo, deleteTask } from '@/myTasks/services';
import { formatNameDay, formatInMeridianTime } from '@/common/utils/Date';
import { updateTimeInATask } from '@/myTasks/services/';
import taskFormSkeleton from '@/myTasks/components/skeletons/TaskFormSkeleton';
import StopWatchButton from '@/myTasks/components/StopWatchButton';
import confirmModal from '@/common/components/modal/ConfirmModal';
import { TASK_STATUSES } from '@/myTasks/constants';
import { useSessionStore } from '@/common';

export default {
  components: {
    NavBar,
    StopWatchButton,
    confirmModal,
    taskFormSkeleton,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      task: {},
      coins: {
        description: '',
        coins: 0,
        points: 0,
      },
      loading: false,
      formatNameDay,
      formatInMeridianTime,
      confirmModalData: {
        title: 'Confirm',
        text: 'text',
        confirmButton: () => {},
      },
    };
  },
  provide() {
    return {
      activeTimerProvider: this,
    };
  },
  computed: {
    taskId() {
      return this.$route.params.taskId;
    },
    childName() {
      return this.sessionStore.childName;
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    titlePage() {
      const isEvent = this.task.isEvent;

      if (isEvent) return 'My Calendar';

      return this.userIsAParent ? `${this.childName}'s Tasks` : 'My Tasks';
    },
    showWatch() {
      return Number(this.task.state) >= 4;
    },
    showActions() {
      return Number(this.task.state) === TASK_STATUSES.IN_PROGRESS;
    },
    getTaskTimerSeconds() {
      return this.task.timeSpentSeconds?.all_seconds;
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      this.task = await getTaskInfo(this.taskId);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async toggleTimer({ state }) {
      try {
        await updateTimeInATask(state, this.task.id);
      } catch (error) {
        console.error(error);
      }
    },
    editTask() {
      this.$router.push({
        name: 'edit-task',
        params: { taskId: this.task.id },
      });
    },
    async showDeleteTask() {
      try {
        this.confirmModalData.title = 'Delete';
        this.confirmModalData.text = 'Do you want to delete this task?';
        this.confirmModalData.confirmButton = async () => {
          await deleteTask(this.task.id);
          this.$router.go(-1);
        };
        this.$bvModal.show('confirmModal');
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
img.attachment {
  width: 250px;
  margin: 0 auto;
}

/* @Overrited */
.material-icons-outlined {
  font-size: 22px;
}
</style>
